import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';

class Erreur404 extends Component {
    get labels() {
        return chainesLocales['Erreur404'][this.props.lang];
    }

    render() {
        return (
            <div>{this.labels.text}</div>
        );
    }
}

export default Erreur404